<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    center
    :title="title"
    width="90%"
    append-to-body
  >
    <div class="dialog-content">
      <SiruiSearch
        ref="baseInfoFormRef"
        :query="query"
        :columns="formColumn"
        :rules="topRules"
        :isQueryPanel="false"
        labelWidth="120px"
        @changeMethod="changeMethod"
      ></SiruiSearch>
      <vxe-toolbar size="mini" v-if="status == 'add'">
        <template v-slot:buttons>
          <template>
            <el-button @click="addNewRowHandler" size="small" type="primary" class="vxe-btn-primary"
              >新增</el-button
            >
            <el-button
              @click="deleteBtnClickHandler"
              size="small"
              type="danger"
              class="vxe-btn-delete"
              >删除</el-button
            >
          </template>
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        show-footer
        resizable
        auto-resize
        ref="costTableRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :edit-rules="tableRules"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        :data="tableData"
        :valid-config="{ autoPos: true, message: 'inline' }"
        :columns="tableColumnList"
        @edit-closed="closeEditTableHandler"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        height="300"
      >
      </vxe-grid>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="cancelHandler" size="small">取消</el-button>
        <el-button type="primary" @click="confirmHandler" size="small" v-if="status == 'add'"
          >确认新增</el-button
        >
        <el-button type="primary" @click="confirmHandler" size="small" v-if="status == 'edit'"
          >确认调整</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import { formFields, tableRules, formRules } from './index.js';
  import superviseContractAPI from '@/api/receivablesAndPayables/superviseContract.js';
  import XEUtils from 'xe-utils';
  import { expenseTypeDeduplicate } from '../../../expenseTypeDeduplicate';

  export default {
    name: 'AddAndEditCostDialog',
    mounted() {},
    data() {
      return {
        dialogVisible: false,
        loading: false,
        query: {
          businessCategory: '03',
          customerNo: null,
          customerName: null,
        },
        tableData: [],
        selectionList: [],
        title: '', //弹窗顶部名称
        status: '', //进入状态（add,edit）
        customerList: [], //客户列表
        ids: [],
      };
    },
    methods: {
      formatMonth(date) {
        return XEUtils.toDateString(date, 'yyyy-MM');
      },
      async changeMethod({ val, prop }) {
        console.log(val, prop, '点击切换');
        const rowData = val && Array.isArray(val) ? val[0] : val;
        console.log('rowData', rowData);
        if (prop == 'contractNo') {
          this.tableData = [];
          this.parseContractDetail(rowData);
        } else if (prop == 'customerNo') {
          this.query.customerNo = rowData;
          this.query.customerName = this.customerList?.find((item) => item.value == rowData)?.label;
        }
      },
      parseContractDetail(detail) {
        if (detail?.customerInfoEntityList && detail?.customerInfoEntityList.length > 0) {
          this.customerList = this.parseCustomers(detail.customerInfoEntityList[0]);
          this.query.customerNo = this.customerList[0].value;
          this.query.customerName = this.customerList[0].label;
        } else {
          this.customerList = [];
        }
        this.query = {
          ...this.query,
          contractNo: detail?.contractNo,
          projectInitiationNo: detail?.projectCode,
          projectName: detail?.projectName,
        };
      },
      parseCustomers(customers) {
        let list = [];
        if (customers.customerNameOne && customers.customerNameOne.length) {
          list.push({ label: customers.customerNameOne, value: customers.customerCodeOne });
        }
        if (customers.customerNameTwo && customers.customerNameTwo.length) {
          list.push({ label: customers.customerNameTwo, value: customers.customerCodeTwo });
        }
        if (customers.customerNameThree && customers.customerNameThree.length) {
          list.push({ label: customers.customerNameThree, value: customers.customerCodeThree });
        }
        return list;
      },
      async openModal(data) {
        console.log('dialogData', data);
        if (data && data.length != 0) {
          this.title = '调整费用';
          this.status = 'edit';
          let list = Array.from(data);
          this.tableData = list;
          let detail = await this.getContractDetail(list[0].contractNo);
          this.parseContractDetail(detail);
        } else {
          this.title = '新增费用';
          this.status = 'add';
          this.tableData = [];
          this.query = {
            businessCategory: '03',
            customerNo: null,
            customerName: null,
          };
        }
        this.dialogVisible = true;
      },
      cancelHandler() {
        this.dialogVisible = false;
      },
      async confirmHandler() {
        const postData = await this.getValidateTableData();
        if (postData) {
          this.loading = true;
          const { data } = await this.$axios.post(
            superviseContractAPI.ADD_EXPENSE,
            postData.tableData
          );
          this.loading = false;
          if (data.code == 0) {
            this.$message.success(this.status == 'add' ? '新增成功' : '调整成功');
            this.dialogVisible = false;
            this.$emit('complete');
          } else {
            this.$message.error(data.msg);
          }
        }
      },
      async getContractDetail(contractNo) {
        const { data } = await this.$axios.post('/sales/contractInfo/listContractByPage', {
          contractNo,
        });
        if (data.code == 0) {
          let list = data.data;
          return list[0];
        } else {
          this.$message.error(data.msg);
        }
        return null;
      },
      // 删除行
      deleteBtnClickHandler() {
        console.log('selectionList', this.selectionList);
        if (!this.selectionList.length) {
          this.$message.error('请选择行再删除');
          return;
        }
        const XIDList = this.selectionList.map((item) => item._XID);
        const idList = this.selectionList.map((item) => item.id).filter((item) => Boolean(item));
        this.ids = [...this.ids, ...idList];
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
      },
      // 新增一行
      async addNewRowHandler() {
        const $table = this.$refs.costTableRef;
        const { row } = await $table.insertAt(
          { exchangeRate: '1', currencyCode: 'CNY', createMethod: '02' },
          0
        );
        await $table.setActiveRow(row);
      },
      // 更新列
      updateCol(row, fieldValue, field) {
        console.log(row, fieldValue, field, '====>');
        row[field] = fieldValue;
        if (field == 'originalPrice' || field == 'statementQuantity') {
          let price = Number(row['originalPrice']);
          let quantity = Number(row['statementQuantity']);
          let exchangeRate = Number(row['exchangeRate']);
          price = isNaN(price) ? 0 : price;
          quantity = isNaN(quantity) ? 0 : quantity;
          exchangeRate = isNaN(exchangeRate) ? 1 : exchangeRate;

          row['originalAmount'] = price * quantity;
          row['domesticAmount'] = price * quantity * exchangeRate;
        } else if (field == 'originalAmount') {
          row['domesticAmount'] = row['originalAmount'];
        }
      },
      rowChange(key, row) {
        console.log('selectionChange', key, row);
        if (key == 'accountPeriod') {
          row['accountPeriod'] = XEUtils.toDateString(row.accountPeriod, 'yyyy-MM');
        } else if (key == 'expenseType') {
          row['expenseTypeName'] = this.expenseList.find(
            (item) => item.value == row.expenseType
          )?.label;
        } else if (key == 'unit') {
          row['unitName'] = this.dictListMap?.basic_unit.find(
            (item) => item.value == row.unit
          )?.label;
        }
        console.log('rowChanged', row);
      },
      // 选择行
      handleSelectionChange(row) {
        this.selectionList = row.selection;
        console.log('selectionList', this.selectionList);
      },
      // 关闭的时候
      closeEditTableHandler() {},
      // 获取表格数据
      async getValidateTableData() {
        this.closeEditTableHandler();
        let form = await this.$refs.baseInfoFormRef.getValidateFormData();

        return new Promise((resolve, reject) => {
          const $table = this.$refs.costTableRef;
          const tableData = $table.getTableData().fullData;
          if (!tableData || tableData.length == 0) {
            this.$message.error('请检查表格数据填写');
            reject(null);
          }
          $table.validate((valid) => {
            if (valid) {
              const formTableData = tableData.map((item) => {
                return {
                  ...item,
                  ...form,
                  departmentCode: this.userInfo.departmentCode,
                  departmentName: this.userInfo.departmentName,
                  companyCode: this.userInfo.companyCode,
                  companyName: this.userInfo.companyName,
                  businessCompanyNo: this.userInfo.companyCode,
                  businessCompanyName: this.userInfo.companyName,
                  businessDepartmentCode: this.userInfo.departmentCode,
                  businessDepartmentName: this.userInfo.departmentName,
                  originalAmount: item.originalAmount ? Number(item.originalAmount).toFixed(6) : 0,
                  domesticAmount: item.domesticAmount ? Number(item.domesticAmount).toFixed(6) : 0,
                };
              });
              resolve({ tableData: formTableData });
            } else {
              this.$message.error('请检查表格数据填写');
            }
          });
        });
      },
      getTableData() {
        const $table = this.$refs.costTableRef;
        return $table.getTableData().fullData;
      },
      fullTableData(tableData) {
        this.tableData = tableData;
      },
    },
    computed: {
      formColumn() {
        return formFields(this);
      },
      tableColumnList() {
        let list = [
          {
            field: 'expenseType',
            title: '费用类型',
            width: 150,
            editRender: {
              name: 'ElSelect',
              props: {
                filterable: true,
                clearable: true,
                filterable: true,
              },
              events: { change: (obj) => this.rowChange('expenseType', obj.row) },
              options: this.expenseList,
              changeMethod: 'changeMethod',
            },
          },
          {
            field: 'accountPeriod',
            title: '应收账期',
            width: 240,
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                valueFormat: 'yyyy-MM',
                format: 'yyyy-MM',
                type: 'month',
              },
              events: { change: (obj) => this.rowChange('accountPeriod', obj.row) },
            },
          },
          {
            field: 'periodDateFrom',
            title: '业务结算日期从',
            width: 240,
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                valueFormat: 'yyyy-MM-dd',
              },
            },
          },
          {
            field: 'periodDateUntil',
            title: '业务结算日期至',
            width: 240,
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                valueFormat: 'yyyy-MM-dd',
              },
            },
          },
          {
            field: 'originalPrice',
            title: '结算单价（含税）',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['originalPrice']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['originalPrice']}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.updateCol(row, val, 'originalPrice')}
                  ></InputNumberAd>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'statementQuantity',
            title: '结算数量',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['statementQuantity']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['statementQuantity']}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.updateCol(row, val, 'statementQuantity')}
                  ></InputNumberAd>,
                ];
              },
            },
            width: 120,
          },
          {
            field: 'unit',
            title: '计量单位',
            editRender: {
              name: 'ElSelect',
              props: {
                clearable: true,
              },
              options: this.dictListMap?.basic_unit,
              events: { change: (obj) => this.rowChange('unit', obj.row) },
              changeMethod: 'changeMethod',
            },
            width: 120,
          },
          {
            field: 'originalAmount',
            title: '原币结算金额（含税）',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['originalAmount']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['originalAmount']}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.updateCol(row, val, 'originalAmount')}
                  ></InputNumberAd>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'currencyCode',
            title: '币种',
            width: 120,
          },
          {
            field: 'exchangeRate',
            title: '汇率',
            width: 120,
          },
          {
            field: 'domesticAmount',
            title: '本币结算金额（含税）',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['domesticAmount']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['domesticAmount']}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.updateCol(row, val, 'domesticAmount')}
                  ></InputNumberAd>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'remark',
            title: '备注',
            width: 150,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
        ];
        if (this.status == 'add') {
          let addList = [
            { type: 'checkbox', width: 50 },
            { type: 'seq', title: '序号', width: 50 },
          ];
          addList = addList.concat(list);
          return addList;
        } else {
          let editList = [];
          editList.push({
            field: 'expenseNo',
            title: '费用编号',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: false,
                disabled: true,
              },
            },
            width: 120,
          });
          editList = editList.concat(list);
          editList.pop();
          console.log('editList', editList);
          return editList;
        }
      },
      expenseList() {
        return expenseTypeDeduplicate(this);
      },
      tableRules() {
        return tableRules();
      },
      topRules() {
        return formRules();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
